(function($, window) {
	var $formOverlay,
		$formModal,
		$main;
	
	$(document).ready(function() {
		if ($('body').hasClass('not-logged-in')) {
			$('.widgetSimpleForm form').each(function(idx, form) { submitTo(form, formhandle) });
		} else {
			$('body').on('submit', '.widgetSimpleForm form', function() {
				return false;
			});
		}
		
		if($('.widgetSimpleForm form').length > 0) {
			$formOverlay = $('<div class="widgetSimpleForm form-overlay"></div>');
			$formModal = $('<div class="widgetSimpleForm form-modal"></div>');
			$main = $('#main');

			$formOverlay.on('click', hideModal);
			
			$formModal.appendTo($main);
			$formOverlay.appendTo($main);
		}
	});
	
	function hideModal() {
		$formOverlay.hide();
		$formModal.removeClass('open');
//		$formModal.hide();
		$formModal.empty();
	}
	
	function showModal($form) {
		if(!$form.parents('.widgetSimpleForm').hasClass('modal')) {
			return false;
		}
		
		var $success = $form.siblings('.successMessage');
		
		$formOverlay.show();
		$formModal.html($success.html());
//		$formModal.show();
		$formModal.addClass('open');
		
		$('.modal-ok, .modal-close', $formModal).on('click', hideModal);
		
		return true;
	}

	function formhandle(form) {
		// Create submit handler for contact form
		var f = $(form),
			$btn = $('button', f),
			isBtn = $btn.length > 0,
			orig = 'Send';
		
		// remove previous error messages
		$('.error', f).remove();
		
		if(isBtn) {
			orig = $btn.html();
			$btn.html('Vent');
		} else {
			$btn = $('input[type=submit]', f);
			orig = $btn.val();
			$btn.val('Vent');
		}

		$btn.attr('disabled','disabled');
		
		var formid = $('input[name=formid]', f).val();
		
		var $primary = $('input[name=kom_primary]', f),
			pval = $primary.val();
		if(pval != undefined) {
			pval = btoa(pval + formid);
			$primary.val(pval);
		}
		var $secondary = $('input[name=kom_secondary]', f),
			sval = $secondary.val();
		if(sval != undefined) {
			sval = btoa(sval + formid);
			$secondary.val(sval);
		}
		
		$.post(f.attr('action'), 
				f.serialize(), 
				function(data) { // success
					if(! showModal(f) ) {
						f.closest('.widgetElement').addClass('formSuccess');
					} else {
						$btn.removeAttr('disabled');
						isBtn ? $btn.html(orig) : $btn.val(orig);
					}
				}, 'json')
			.fail(function(data) { // error
				f.prepend('<li class="error">Der skete en fejl: '+Contenda.t(data.responseText)+'</li>');
				$btn.removeAttr('disabled');
				
				isBtn ? $btn.html(orig) : $btn.val(orig);
		});
	}
	
})(jQuery, window);